import { convertUtcToLocalDateTime } from 'helpers/dateHelper';
import { baseToCustomUOM, getMeasurementUnitSymbol } from 'helpers/unitHelper';

export const convertKPIHistogramResponse = (res) => {

    return res?.histograms?.map(histogramData => {
        if (!histogramData?.config) {
            return histogramData;
        }
        const { binUnitGroupId, aggregationUnitGroupId, precision } = histogramData.config;

        histogramData.config.xUnit = getMeasurementUnitSymbol(binUnitGroupId);
        histogramData.config.yUnit = getMeasurementUnitSymbol(aggregationUnitGroupId);
        histogramData.values = baseToCustomUOM.convertMeasurementList(
            histogramData.values,
            { start: binUnitGroupId, end: binUnitGroupId, value: aggregationUnitGroupId },
            precision
        );
        histogramData.values = histogramData.values.map(value => {
            value.label = `${value.start} - ${value.end}`;
            return value;
        });

        return histogramData;
    });
};

export const formatKPIScatterResponse = (res) => {
    return res.map(scatterData => {
        if (!scatterData?.config) {
            return scatterData;
        }
        const { xUnitGroupId, yUnitGroupId, precision } = scatterData.config;
        scatterData.config.xUnit = getMeasurementUnitSymbol(xUnitGroupId);
        scatterData.config.yUnit = getMeasurementUnitSymbol(yUnitGroupId);
        scatterData.values = baseToCustomUOM.convertMeasurementList(
            scatterData.values,
            { x: xUnitGroupId, y: yUnitGroupId },
            precision
        );

        scatterData.values = scatterData.values.map(v => {
            return {
                date: convertUtcToLocalDateTime(v.timestamp),
                x: v.x,
                y: v.y,
            };
        });

        return scatterData;
    });
};
